<template>
	<div class="about-corner">
		<div class="page-container">
			<PageTitle ch="空間介紹" en="Spaces"></PageTitle>
			<SpaceIntro></SpaceIntro>
		</div>
	</div>
</template>

<script>
import PageTitle from '@/components/page_title'
import SpaceIntro from '@/components/space_intro'

export default {
  metaInfo: {
    title: '利澤國際偶戲藝術村'
  },
  name: 'about-corner',
  data() {
    return {
    }
  },
  components: {
    PageTitle,
    SpaceIntro
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="sass">
  @import '../../stylesheet/base.sass'
  @import '../../stylesheet/layout.sass'

  .about-corner
    .page-container
      min-height: 500px !important
      iframe
        +size(100%, 1000px)
</style>



// WEBPACK FOOTER //
// src/pages/about/about_corner.vue